import o, { useState as C } from "react";
import { useTranslation as y } from "react-i18next";
import { Modal as s } from "../../../../common/components/Modal/Modal.js";
import { OtpInput as B } from "../../../../common/components/forms/OtpInput/OtpInput.js";
import { useCountDown as S } from "../../../../dom/hooks/useCountDown.js";
import e from "./phoneVerification.module.scss.js";
function w({ seconds: a, onResend: n }) {
  const { t: c } = y(), [r] = S(a, !0), u = `${String(Math.floor(r / 60)).padStart(2, "0")}:${String(r % 60).padStart(2, "0")}`;
  return r > 0 ? /* @__PURE__ */ o.createElement("span", { className: e.countdown }, c("phoneVerification.countdown", { time: u })) : /* @__PURE__ */ o.createElement(
    "button",
    {
      className: e.resendButton,
      type: "button",
      onClick: n
    },
    c("phoneVerification.resend")
  );
}
function M({
  show: a,
  phoneNumber: n,
  onClose: c,
  onBack: r,
  onSubmit: u,
  onResend: m,
  design: t,
  countdownSeconds: E = 30,
  errorMessage: b,
  dismissOnBackdrop: v,
  dismissOnEscape: x
}) {
  const { t: l } = y(), [f, p] = C(""), [h, N] = C(0);
  o.useEffect(() => {
    a || p("");
  }, [a]);
  const k = () => {
    N((i) => i + 1), m == null || m();
  }, V = {
    "--pv-text-color": (t == null ? void 0 : t.textColor) ?? "#fff",
    "--pv-btn-bg": (t == null ? void 0 : t.buttonBackgroundColor) ?? "#f8b233",
    "--pv-btn-text": (t == null ? void 0 : t.buttonTextColor) ?? "#fff",
    "--pv-secondary-btn-bg": (t == null ? void 0 : t.secondaryButtonBackgroundColor) ?? "#cabed3",
    "--pv-secondary-btn-text": (t == null ? void 0 : t.secondaryButtonTextColor) ?? "#302e3a"
  };
  return /* @__PURE__ */ o.createElement(
    s,
    {
      show: a,
      showCloseBtn: !1,
      onClose: c,
      dismissOnBackdrop: v,
      dismissOnEscape: x,
      design: {
        backgroundColor: (t == null ? void 0 : t.backgroundColor) ?? "#302e3a",
        textColor: (t == null ? void 0 : t.textColor) ?? "#fff",
        fontFamily: t == null ? void 0 : t.fontFamily
      }
    },
    /* @__PURE__ */ o.createElement("div", { className: e.container, style: V }, /* @__PURE__ */ o.createElement("div", { className: e.title }, l("phoneVerification.title")), /* @__PURE__ */ o.createElement("div", { className: e.subtitle }, l("phoneVerification.subtitle", { phoneNumber: n })), /* @__PURE__ */ o.createElement(
      B,
      {
        value: f,
        onChange: p,
        design: {
          textColor: (t == null ? void 0 : t.textColor) ?? "#fff",
          borderColor: (t == null ? void 0 : t.borderColor) ?? "#9c4ed8"
        }
      }
    ), b && /* @__PURE__ */ o.createElement("div", { className: e.error }, b), /* @__PURE__ */ o.createElement(
      w,
      {
        key: h,
        seconds: E,
        onResend: k
      }
    ), /* @__PURE__ */ o.createElement("div", { className: e.buttons }, r && /* @__PURE__ */ o.createElement(
      "button",
      {
        className: e.secondaryButton,
        type: "button",
        onClick: r
      },
      l("phoneVerification.back")
    ), /* @__PURE__ */ o.createElement(
      "button",
      {
        className: e.submitButton,
        type: "button",
        disabled: f.length < 4,
        onClick: () => u(f)
      },
      l("phoneVerification.continue")
    )))
  );
}
export {
  M as PhoneVerification
};
//# sourceMappingURL=PhoneVerification.js.map
